/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "BarChart2Icon",
  },
  {
    url: "/administradores",
    name: "Administradores",
    slug: "administradores",
    icon: "UserCheckIcon",
  },
  {
    url: "/psicologos",
    name: "Profissionais",
    slug: "psicologos",
    icon: "UserPlusIcon",
  },
  {
    url: "/pacientes",
    name: "Pacientes",
    slug: "pacientes",
    icon: "UserIcon",
  },
  {
    url: "/especialidades",
    name: "Especialidades",
    slug: "especialidades",
    icon: "StarIcon",
  },
  {
    url: "/status-consultas",
    name: "Status (Consultas)",
    slug: "status-consultas",
    icon: "CheckCircleIcon",
  },
  {
    url: "/empresas",
    name: "Empresas",
    slug: "empresas",
    icon: "BriefcaseIcon",
  },
  {
    url: "/vouchers",
    name: "Vouchers Empresariais",
    slug: "vouchers",
    icon: "TagIcon",
  },
  {
    url: "/consultas",
    name: "Consultas",
    slug: "consultas",
    icon: "CalendarIcon",
  },
  {
    url: "/anonimizar",
    name: "Anonimização",
    slug: "anonimizar",
    icon: "UserMinusIcon"
  },
]
